var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('h1',[_vm._v("Settings")]),_c('v-sheet',{staticClass:"pa-10"},[_c('v-switch',{attrs:{"hide-details":"","color":"info","inset":"","label":"Enable dark theme"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }